import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export default function PrivateRoute({ children }) {
  const auth = useSelector((state) => state.auth);
  const location = useLocation();

  if (auth.loading) return null;
  if (!auth.isAuthenticated) {
    const redirect = encodeURIComponent(`${location.pathname}${location.search || ""}`);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }
  return children;
}
